<style lang='scss'>
	#noscorll::-webkit-scrollbar{
		display:none
	}
	#handcaozuo .ant-modal-header,
	#handcaozuo .ant-modal-body {
		background-color: #e5e5e5 !important;
		padding: 1rem;
		padding-top: 0.7rem;
	}
	
	#handcaozuo {
		.tableBzViewBtnView{text-align: center;}
		.tableBzViewBtn {
			margin: 0 1.5rem !important;
			// padding: 1rem;
			color: #fff;
		}
		.ant-form-explain{
			display: none;
		}
	
		.ant-col-12 {
			text-align: right;
		}
	
		.ant-form-item-label {
			width: 30%;
		}
		.ant-form-item, .ant-form-item-control{
			width: 100%;
			.ant-calendar-picker{
				width: 100%;
			}
			
		}
		
		.ant-form-item-control-wrapper{
			width:70%;
			.ant-form-item-control{
				width: 100%;
			}
		}
		.ant-form-inline .ant-form-item {
			margin-right: 0;
		}
		.ant-modal-content {
			border-radius: 10px;
		}
	
		.ant-form-item {
			margin-bottom: 1rem;
		}
	
		.ant-form-item label {
			font-size: .8rem !important;
		}
	
		.ant-input {
			font-size: .8rem !important;
		}
	
		.ant-select-selection-selected-value {
			font-size: .8rem !important;
		}
	
		.ant-form-item-children {
			font-size: .8rem !important;
		}
	
		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
			padding-bottom: 1px;
		}
	}
	#handcaozuo {
		.ant-modal-root .ant-modal-close-x .anticon svg{
			    top: 1.6rem;
			    right: 1.6rem;
		}
		/* .ant-modal-close{
			    top: -.2rem;
			    right: -1rem;
		} */
		.lable_green {
			color: #0c8b97;
			font-size: .8rem;
			margin-bottom: 0.8rem;
		}


		.wland {
			display: inline-block;
			/* width: 4rem; */
			/* padding: .4rem 0; */
			margin-right: 1rem;
			text-align: center;
			background-color: #fff;
			color: #09666e;
			border-bottom: .2rem solid #09666e;
			font-size: .8rem;
		}

		.gland {
			display: inline-block;
			/* width: 4rem; */
			/* padding: .4rem 0; */
			margin-right: 1rem;
			text-align: center;
			color: #000;
			font-size: .8rem;
		}

		.paginationView {
			padding: 0.5rem 0.5rem;
			display: flex;
			align-items: center;
			width: 100%;
			color: #666666;
			/* height:calc(100vh - 142px); */
		}
	}

	#tubody-mainsk>div {
		padding: 1px 0;
	}

	#tubody-mainsk {
		background-color: #fff;

		.ant-empty-normal {
			margin: 7rem 0;
		}

		.main-wid {
			width: 85%;
			height: 1px;
			border-top: .5px solid #d8d8d8;
			margin: 1rem 0;
		}

		.ant-col {
			font-size: .8rem;
			color: #000;
			margin: .2rem 0;
		}

		.btn {
			cursor: pointer;
			width: 6rem;
			height: 2rem;
			font-size: 0.8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			text-align: center;
			line-height: 2rem;
			background-color: #0c8b97;
			margin: 1rem;
		}

		.btn1 {
			cursor: pointer;
			width: 5rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			/* border-radius: 5px; */
			margin: 0 1rem;
			background-color: #0c8b97;
		}

		.warp_daochu {
			border-top: 1px solid rgb(232, 232, 232);
			display: flex;
			justify-content: space-between;
			padding: 1rem .5rem;

			div {
				font-size: .7rem;
			}
		}
	}
	.warp_simg{
		width: .8rem;
		cursor: pointer;
		height: .9rem;
	}
</style>
<template>
	<div>
		<a-modal id='handcaozuo' width='45rem' v-model="visible" on-ok="handleOk"
					v-dragModal
					:dialog-style="{ top:'5vh' }"
					@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
					<div class='mark-file'>
						<div  v-html='"問題話術"'
							style="background-color: #0c8b97;border-radius:  10px 10px 0 0;color: #fff;width: 43rem;margin: 1rem 1rem 0 1rem;text-align: center;">
						</div>
					</div>
					<div style="width: 43rem;padding: 1rem 1rem .8rem 1rem;border-bottom: 1px solid rgb(232, 232, 232);background-color: #fff;    margin: 1rem 1rem 0px;">
						<a-input style='width: 15rem;' v-model='searchstr' @blur='getdate' @pressEnter='getdate' placeholder='請輸入搜索內容'>
							<a-tooltip slot="prefix" title="搜索">
							        <a-icon type="search" style='font-size: .9rem;' @click='getdate'/>
							      </a-tooltip>
						</a-input>
						 </div>
					<div style="width: 43rem;" class='body_lis'>
						<div>
			<div style="display: flex;border-bottom: 1px solid rgb(232, 232, 232);padding-bottom: .8rem;">
				<div v-for='(item,ind) in params.FQAtypeList' :key='ind + "0716"' v-if='!item.ishand'
					:class='island == item.typeid?"wland":"gland"' @click="fanfn(item)">
					{{item.title}}
				</div>
			</div>
			
			<div id='tubody-mainsk'>
				<div style="padding-top: 1rem;height: 57vh;overflow-y: auto;" id='noscorll'>
						<div v-for="(item,index) in params.FQAList" :key="index + '11111'">
							<div>
								<div style="display: flex;justify-content: space-between;">
									<div  class='lable_green'>{{item.question}}</div>
									
									<img :src="require('@/image/baocun1.png')" alt="" class='warp_simg' @click='handcope(item.answer)'>
								</div>
								<pre class='fonts '>{{item.answer}}</pre>
							</div>
							<div
								style="width: 100%;height: 1px;border-bottom: 1px solid rgb(232, 232, 232);margin-bottom: .8rem;">
							</div>
						</div>
				</div>
				<div id='supplylist'>
					<div class="paginationView">
						<div></div>
						<div style="margin-left:auto;">
							<a-pagination v-model="params.pageNum" @change="pageChange" :total="params.total"
								:pageSize="params.perPage" />
						</div>
						<div class="pageTzView">
							<input type="text" v-model="tzPageNum" @onkeyup="valueFn" @onafterpaste="valueFn">
							<span @click="tzEvent">跳轉</span>
						</div>
						<!-- kangfende ren changqi weichi zhezhongzhuangkuang guofen yanggan qiankanglongyouhui roude yimian fayangchulai dache dawu zhegexianxiang jiule yidingshizheyangd edajiadouhuilaole dacehedawi dagaigewiyige qusgu feucgabfd feichangde ren jlao -->
					</div>
				</div>
				<!-- <div style="width: 100%;height: 1px;border-bottom: 1px solid rgb(232, 232, 232);margin-bottom: .4rem;"></div> -->
				<!-- <div class='warp_mess'>
					<button class='btn1' @click='resetForm("1")'>保存</button>
				</div> -->
			</div>
			
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';

	export default {
		name: 'handhome',
		props: ['itemobj'],
		components: {},
		data() {
			return {
				tzPageNum: '',
				searchstr: '',
				params: { // 任務數
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					hot_status: '',
					perPage: 10, //每頁條目數
					FQAList:[],
					FQAtypeList:[]
				},
				visible: true,
				island: 1,
			}
		},
		mounted() {
			this.getdate();
		},
		watch: {
			itemobj: {
				deep: true,
				immediate: true,
				handler(ev) {}
			},
		},
		methods: {
			handcope(value){
				let _this=this;
				let clipboard = new this.$clipboard('img', {
				    text: function () {
				        return value
				    }
				})
				clipboard.on('success', e => {
					_this.$message.success('複製成功')
				    clipboard.destroy(e)
				})
				clipboard.on('error', e => {
					_this.$message.warning('複製失敗')
				    clipboard.destroy(e)
				})
			},
			fanfn(v){
				this.island = v.typeid
				this.getdate(v.typeid);
			},
			valueFn() {
				this.tzPageNum = this.tzPageNum.replace(/\D/g, '')
			},
			substr(str, a, b) {
				return str.toString().substring(a, b)
			},
			tzEvent() {
				let _this = this;
				let maxPageNum = Math.ceil(_this.params.total / _this.params.perPage);
				if (_this.tzPageNum <= maxPageNum) {
					_this.params.pageNum = Number(_this.tzPageNum);
					_this.getdate();
				} else {
					App.oTool.warningT('請輸入有效的頁碼');
				}
			},
			pageChange(page, pageSize) {
				this.params.pageNum = page;
				this.getdate();
			},
			getdate() {
				this.$ajax({
					method:'post',
					url:this.$api.getTalkFAQ,
					data:{
						"searchstr":this.searchstr,
						 "typeid":this.island,
						 "pageNum":this.params.pageNum,
						 "perPage":5
					}
				}).then(res=>{
					if(res.data.qmiscode === 1000){
						this.params = res.data
					}
				})
			},
			handleOk() {

			},
			resetForm(){
				return
				this.$ajax({
					method:'post',
					// url :this.$api.xxx
				}).then(res=>{
					if(res.data.qmiscode === 1000){
						
					}
				})
			},
			handleCancel() {
				this.$emit('child', 1)
			},
		}
	}
</script>
